import React from "react";
import { Card, CardHeader, CardBody, Collapse, Container } from "reactstrap";
import AuthHeader from "components/Headers/AuthHeader.js";
import { useFaqSchema } from "components/Public/PublicBlocks";
import {
  OBJECTION_FAQS,
  PLATFORM_FEE_PERCENT,
  PRO_PAYOUT_PERCENT,
  FACEBOOK_URL,
} from "variables/publicContent";

function FAQ() {
  const [openedCollapses, setOpenedCollapses] = React.useState([]);

  React.useEffect(() => {
    document.title = "FAQ - Bite Logr";
    // eslint-disable-next-line
  }, []);
  useFaqSchema(OBJECTION_FAQS);
  const collapsesToggle = (collapse) => {
    if (openedCollapses.includes(collapse)) {
      setOpenedCollapses([]);
    } else {
      setOpenedCollapses([collapse]);
    }
  };
  return (
    <>
      <AuthHeader title="FAQ" lead="" deviceType={false} />
      <Container className="p-2 mt--8">
        <div className="accordion">
          {OBJECTION_FAQS.map((f) => (
            <Card className="card-plain" key={f.id}>
              <CardHeader
                role="tab"
                onClick={() => collapsesToggle("faq-" + f.id)}
                aria-expanded={openedCollapses.includes("faq-" + f.id)}
              >
                <h5 className="mb-0">{f.q}</h5>
              </CardHeader>
              <Collapse
                role="tabpanel"
                isOpen={openedCollapses.includes("faq-" + f.id)}
              >
                <CardBody>{f.a}</CardBody>
              </Collapse>
            </Card>
          ))}
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseFive")}
              aria-expanded={openedCollapses.includes("collapseFive")}
            >
              <h5 className="mb-0">Need support?</h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseFive")}
            >
              <CardBody>
                <a
                  href={FACEBOOK_URL}
                  target="_blank"
                >
                  Message us on Facebook!
                </a>
              </CardBody>
            </Collapse>
          </Card>
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseMoney")}
              aria-expanded={openedCollapses.includes("collapseMoney")}
            >
              <h5 className="mb-0">
                As a professional, how exactly do I make money?
              </h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseMoney")}
            >
              <CardBody>
                As a professional angler, you create subscription plans with
                your own monthly pricing. You choose what catch details (like
                lure, location, weather, etc.) each plan includes. Subscribers
                pay for access to your fishing data, and Bite Logr collects
                those payments and pays you monthly via direct deposit. We keep{" "}
                {PLATFORM_FEE_PERCENT}% - you keep {PRO_PAYOUT_PERCENT}%.
              </CardBody>
            </Collapse>
          </Card>
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseOne")}
              aria-expanded={openedCollapses.includes("collapseOne")}
            >
              <h5 className="mb-0">What should I do first?</h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseOne")}
            >
              <CardBody>
                Well that depends on which type of angler you are...
                professional or looking to follow pros.
                <br />
                <br />
                <strong>Professional</strong>
                <br />
                Registration will walk you through setting up your profile and
                plans. After that, add some fish pictures! From there, it is on
                you to share your profile on your social media. This will drive
                people looking at following you to your profile and encourage
                subscriptions. If you need help with marketing materials, reach
                out!
                <br />
                <br />
                <strong>Angler</strong>
                <br />
                Register then follow and support your favorite pros! You can
                also add your own catches to get more out of Bite Logr!
              </CardBody>
            </Collapse>
          </Card>
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseTwo")}
              aria-expanded={openedCollapses.includes("collapseTwo")}
            >
              <h5 className="mb-0">How easy is it to record a catch?</h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseTwo")}
            >
              <CardBody>
                We wanted this to be as easy as possible to do on the water. If
                you catch a fish, just take a photo of it. When you upload the
                photo into BoiteLogr, we will automatically record the location
                of the photo, weather, moon phase, date and time of the catch.{" "}
                <br />
                You can then select the lure you caught it with and add any
                other information you might want like size of the fish, notes,
                status of the tide, trolling speed, etc.
              </CardBody>
            </Collapse>
          </Card>
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseFour")}
              aria-expanded={openedCollapses.includes("collapseFour")}
            >
              <h5 className="mb-0">Is my data private?</h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseFour")}
            >
              <CardBody>
                YES!
                <br />
                We are fisherman and know how many years it takes to become a
                consistent fisherman. This is ALL experience and we are hoping
                BiteLogr can help you focus that experience to help you catch
                more in the future.
                <br />
                So your data will be ONLY YOUR DATA. The data you upload will
                not be used to help others! On top of that, everything stored in
                our system is encrypted and tied to your unique password. No one
                will be able to see your catches or learn anything from them.
                <br />
                As a professional, YOU decide what about your catches are
                shared. The more your subscribers pay, the more data they get
                access to. You are in control of this completely.
              </CardBody>
            </Collapse>
          </Card>
          <Card className="card-plain">
            <CardHeader
              role="tab"
              onClick={() => collapsesToggle("collapseThree")}
              aria-expanded={openedCollapses.includes("collapseThree")}
            >
              <h5 className="mb-0">What features are coming up?</h5>
            </CardHeader>
            <Collapse
              role="tabpanel"
              isOpen={openedCollapses.includes("collapseThree")}
            >
              <CardBody>
                We have a lot in mind!
                <ul>
                  <li>
                    Better ways for professionals to engage with their
                    subscribrs and make money. Messaging and premium content are
                    on the short list.
                  </li>
                  <li>
                    We have some simple analysis features right now that allow
                    you to see your top lures, locations and weather patterns.
                    But we are taking that a step further by using your past
                    catches to help us make recommendations to you. Is it cloudy
                    right now? Maybe you should throw a green bait because you
                    catch a lot of fish with green lures in cloudy conditons.
                    Maybe you can hone in on a depth based on current weather
                    and water conditions? The possibilities here are pretty
                    endless.
                  </li>
                </ul>
              </CardBody>
            </Collapse>
          </Card>
        </div>
      </Container>
    </>
  );
}

export default FAQ;
